export const DEFAULT_PER_PAGE = 20

export interface PaginationDetails {
  onPageChange?: (page: number) => void
  page: number
  pageCount: number
  perPage?: number
  totalResults: number
}
